
  import { defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { TodoRecord } from '@/entities/todo';

  interface ContinueInspectionProps {
    todo: TodoRecord;
    tooltipContent: string | null;
  }

  export default defineComponent<ContinueInspectionProps>({
    name: 'InspectionIndexPage',
    components: { Tooltip, Button },
    props: ['todo', 'tooltipContent'],
    setup(props) {
      const route = {
        name: 'inspectionEdit',
        params: { id: props.todo.data.inspection!.id!.toString() },
      };

      return {
        route,
      };
    },
  });
